import { TrendingUp } from "lucide-react";
import type { AnalysisResearch } from "@erc/shared";

// Satis kaniti (ChatGPT create_analysis ile gelen ilham analizlerinde):
// sayfada GOZLENEN veri, Etsy API'sinden alinan anlik veri ve ChatGPT'nin
// yorumu ayri gosterilir — yorum kanit gibi okunmasin.
const fmt = (n: number | null | undefined) => (n == null ? "—" : n.toLocaleString("tr-TR"));

export function SalesEvidence({ research }: { research: AnalysisResearch }) {
  const e = research.evidence ?? {};
  const et = research.etsy;
  const observed: Array<[string, string]> = [];
  if (e.bestseller) observed.push(["Rozet", "Bestseller"]);
  if (e.popularNow) observed.push(["İşaret", "Popular now"]);
  if (e.listingReviews != null) observed.push(["Ürün yorumu", fmt(e.listingReviews)]);
  if (e.rating != null) observed.push(["Puan", `${e.rating}/5`]);
  if (e.favorites != null) observed.push(["Favori (sayfa)", fmt(e.favorites)]);
  if (e.inCartsNote) observed.push(["Sepet", e.inCartsNote]);
  if (e.recentReviewDates?.length) observed.push(["Son yorumlar", e.recentReviewDates.join(", ")]);
  if (e.season) observed.push(["Sezon", e.season]);

  return (
    <section className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
      <div className="mb-3 flex items-center gap-2">
        <TrendingUp className="h-4 w-4 text-emerald-600" />
        <h3 className="text-sm font-semibold text-gray-900">Satış kanıtı</h3>
        {research.observedAt && (
          <span className="ml-auto text-[11px] text-gray-400">{new Date(research.observedAt).toLocaleDateString("tr-TR")} · {research.source === "chatgpt" ? "ChatGPT" : research.source}</span>
        )}
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <div>
          <p className="mb-1.5 text-[11px] font-medium uppercase tracking-wide text-gray-400">Sayfada görülen</p>
          {observed.length ? (
            <dl className="space-y-1 text-sm">
              {observed.map(([k, v]) => (
                <div key={k} className="flex gap-2"><dt className="w-28 shrink-0 text-gray-500">{k}</dt><dd className="text-gray-800">{v}</dd></div>
              ))}
            </dl>
          ) : <p className="text-sm text-gray-400">Kayıt yok</p>}
        </div>
        {et && (
          <div>
            <p className="mb-1.5 text-[11px] font-medium uppercase tracking-wide text-gray-400">Etsy verisi (otomatik)</p>
            <dl className="space-y-1 text-sm">
              <div className="flex gap-2"><dt className="w-28 shrink-0 text-gray-500">Favori</dt><dd className="text-gray-800">{fmt(et.favorites)}</dd></div>
              <div className="flex gap-2"><dt className="w-28 shrink-0 text-gray-500">Görüntülenme</dt><dd className="text-gray-800">{fmt(et.views)}</dd></div>
              {et.price && <div className="flex gap-2"><dt className="w-28 shrink-0 text-gray-500">Fiyat</dt><dd className="text-gray-800">{et.price} {et.currency}</dd></div>}
              {et.shop && (
                <div className="flex gap-2"><dt className="w-28 shrink-0 text-gray-500">Mağaza</dt><dd className="text-gray-800">{et.shop.name} · {fmt(et.shop.sold)} satış · {et.shop.reviewAverage ?? "—"}★</dd></div>
              )}
            </dl>
          </div>
        )}
      </div>

      {e.buyerSignals?.length ? (
        <div className="mt-3">
          <p className="mb-1 text-[11px] font-medium uppercase tracking-wide text-gray-400">Alıcı nedenleri (yorumlardan)</p>
          <ul className="list-disc space-y-0.5 pl-5 text-sm text-gray-700">{e.buyerSignals.map((s, i) => <li key={i}>{s}</li>)}</ul>
        </div>
      ) : null}

      {research.reason && (
        <div className="mt-3 rounded-lg border border-amber-100 bg-amber-50/60 p-3">
          <p className="mb-0.5 text-[11px] font-medium uppercase tracking-wide text-amber-700">Değerlendirme (yorum, kanıt değil)</p>
          <p className="whitespace-pre-line text-sm text-gray-700">{research.reason}</p>
        </div>
      )}
    </section>
  );
}
